<template>
<div class="containers">
    <div class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="2">
                    <input type="text" v-model="searchUniversal" placeholder="Cari" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchJenis" class="form-control" v-model="searchJenis" placeholder="Jenis Surat"></model-select>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchMasalah" class="form-control" v-model="searchMasalah" placeholder="Kode Klasifikasi"></model-select>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="dateStart" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" :disabled="dateStart==''" :min="dateStart" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="dateEnd" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6">
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" @history="historyData" @file="openFile" @show="showSurat" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="lg"
            :centered="true"
            title="Disposition"
            color="white"
            :show.sync="dispositionModal"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Disposition</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="dispositionModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <CRow style="padding-right:20px;padding-left:20px">
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <label class="mb-2">
                                    Tambah Disposition
                                </label>
                                <div class="autocomplete">
                                    <input type="text"
                                            class="form-control"
                                            @click="toggleVisiblePeserta()"
                                            @blur="toggleCloseVisiblePeserta()"
                                            v-model="queryPeserta"
                                            v-text="selectedItemPeserta ? selectedItemPeserta['text'] : ''"
                                            @keydown.up="upPeserta"
                                            @keydown.down="downPeserta"
                                            @keydown.enter="selectItemPeserta"
                                            placeholder="Pilih Peserta"
                                    >
                                    <div class="popovers" v-show="visiblePeserta">
                                        <div class="options" v-if="matchesPeserta.length != 0 && queryPeserta.length != 0" ref="optionsList">
                                            <ul>
                                            <li v-for="(match, index) in matchesPeserta"
                                                :key="index"
                                                :class="{ 'selected': (selectedPeserta == index)}"
                                                @click="itemClickedPeserta(index)"
                                                v-text="match['text']"></li>
                                            </ul>
                                        </div>
                                        <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length != 0">
                                            Data Tidak Ditemukan
                                        </div>
                                        <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length == 0">
                                            Start Typing...
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-4" v-if="sumPeserta.length != 0">
                            <CCol sm="12">
                                <label class="mb-2">
                                    Daftar Disposition
                                </label>
                                <CRow v-for="(li, id) in sumPeserta" :key="id">
                                    <CCol sm="1">
                                        {{id+1}}.
                                    </CCol>
                                    <CCol sm="10">
                                        {{li.nama}}
                                    </CCol>
                                    <CCol sm="1">
                                        <img :src="closeIcon" @click="deleteSum(id)" style="cursor:pointer" width="10px" height="10px"/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <label class="mb-2">
                                    Action
                                </label>
                                <CRow v-for="(li, id) in dataAksi" :key="id">
                                    <CCol sm="1 pt-1">
                                        <input type="checkbox" :id="li.unix" :name="li.action" class="form-control">
                                    </CCol>
                                    <CCol sm="11">
                                        <label :for="li.unix">{{li.action}}</label>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow class="mt-3" style="padding-bottom:40px;padding-left:20px;padding-right:20px" v-if="errDisposition != ''">
                    <CCol sm="12">
                        <span class="text-danger">
                            {{errDisposition}}
                        </span>
                    </CCol>
                </CRow>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="dispositionModal = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                    <CCol sm="3">
                        <CButton @click="goSaveDisposition()" class="w-100" color="primary">Simpan</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            title="History Surat"
            color="white"
            :show.sync="historyModal"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>History Surat</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="historyModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <CRow style="padding-right:20px;padding-left:20px">
                    <CCol sm="12">
                        <ul class="StepProgress" v-if="track.length != 0">
                            <li class="StepProgress-item" v-for="(item, index) in track" :key="'track'+index" :class="[item.action != 'S' ? 'is-done' : '']">
                                <div class="font-weight-bold">{{item.nama_Approve_By}}</div>
                                <div>
                                    <span v-if="item.action == 'C'" class="text-primary font-weight-bold">{{item.keterangan_Action}}</span>
                                    <span v-if="item.action == 'R'" class="text-danger font-weight-bold">{{item.keterangan_Action}}</span>
                                    <span v-if="item.action == 'S'" class="text-success font-weight-bold">{{item.keterangan_Action}}</span>
                                    <span v-if="item.action == 'A'" class="text-info font-weight-bold">{{item.keterangan_Action}}</span>
                                    <span v-if="item.action == 'W'" class="text-warning font-weight-bold">{{item.keterangan_Action}}</span>
                                    {{item.reviewer_Ke}} <span v-if="item.tanggal.length != 0">at {{item.tanggal}}</span>
                                </div>
                                <div>{{item.keterangan}}</div>
                            </li>
                        </ul>
                        <span v-if="track.length == 0">Riwayat surat tidak ditemukan</span>
                    </CCol>
                </CRow>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="9"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="historyModal = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '@/component/tableIBC'
import { DataApi, DataApiUpload } from "@/service/DataApi";
export default {
    components: {
        Tables,
    },
    data() {
        return {
            success: true,
            activeTab: 0,
            refreshIcon: require('@/assets/menu/icon_refresh.svg'),
            moreIcon: require('@/assets/menu/icon_more.svg'),
            closeIcon: require('@/assets/menu/icon_close.svg'),
            backIcon: require('@/assets/menu/icon_goback.svg'),
            dataTh: ['Dari', 'Subjek', 'Klasifikasi', 'Dibuat', 'Lampiran', 'Surat'],
            dataTd: ['namaDari', 'Subjek', 'masalah', 'createdDate', 'listLampiran', 'urlSurat'],
            styleTable: ['125px', '200px', '100px', '100px', '100px', '100px', '200px'],
            classReload: 'reloadOff',
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchUniversal: '',
            dataSearchJenis: [],
            searchJenis: {
                value: '',
                text: ''
            },
            dataSearchMasalah: [],
            searchMasalah: {
                value: '',
                text: ''
            },
            dateStart: '',
            dateEnd: '',
            
            // datas
            datas: [],

            //error
            errorMessage: '',

            // delete
            dispositionModal: false,
            historyModal: false,
            track: [],
            dataAksi: [],
            kodeSurat: '',

            // data peserta
            dataPeserta: [],
            titlePeserta:"Pilih Peserta",
            selectedItemPeserta: null,
            selectedPeserta: 0,
            queryPeserta: '',
            visiblePeserta: false,
            idPeserta: '',
            sumPeserta: [],
            errDisposition: '',
            alertMess: '',
            currentAlertCounter: 0,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchUniversal() {
            this.flagSearch = true
        },
        queryPeserta() {
            if(this.queryPeserta == '') {
                this.idPeserta = ''
            }
            this.getDataPeserta()
        },
        dispositionModal() {
            if(this.dispositionModal == false) {
                this.errDisposition = ''
                this.sumPeserta = []
                this.kodeSurat = ''
                this.dataAksi = []
                this.getDataAksi()
            }
        },
        historyModal() {
            if(this.historyModal == false) {
                this.track = []
            }
        }
        
    },
    computed: {
        matchesPeserta() {
            if (this.queryPeserta == '') {
                return [];
            }
            return this.dataPeserta.filter((item) => item['text'].toLowerCase().includes(this.queryPeserta.toLowerCase()))
        },
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kodeMasalah.toLowerCase() < b.kodeMasalah.toLowerCase()) {
                        return -1
                    }
                    if (a.kodeMasalah.toLowerCase() > b.kodeMasalah.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.masalah.toLowerCase() < b.masalah.toLowerCase()) {
                        return -1
                    }
                    if (a.masalah.toLowerCase() > b.masalah.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDataSearchMasalah() {
            let payload = {
                kodeMasalah: "",
                limit: 9999,
                pageIn: 1,
                masalah: ""
            }
            DataApi.post("surat/masalah/lihat", payload)
            .then(res => {
                this.dataSearchMasalah = [{
                    value: '',
                    text: 'Semua Klasifikasi'
                }]
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeMasalah + ' - ' + temp[i].masalah
                        }
                        this.dataSearchMasalah.push(onPush)
                    }
                } else {
                    this.dataSearchMasalah = []
                }
            })
        },
        getDataSearchJenis() {
            let payload = {
                internal: "0",
                jenis: "",
                kodeJenis: "",
                limit: 9999,
                pageIn: 1
            }
            DataApi.post("surat/jenis/lihat", payload)
            .then(res => {
                this.dataSearchJenis = [{
                    value: '',
                    text: 'Semua Jenis Surat'
                }]
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeJenis + ' - ' + temp[i].jenis
                        }
                        this.dataSearchJenis.push(onPush)
                    }
                } else {
                    this.dataSearchJenis = []
                }
            })
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let searchUniversal = this.searchUniversal

            let payload = {
                filterUniversal: searchUniversal,
                isiSurat: "",
                jenisSurat: this.searchJenis.value,
                limit: limit,
                masalah: this.searchMasalah.value,
                namaDari: "",
                namaKepada: "",
                namaOnReview: "",
                nomorSurat: "",
                pageIn: page,
                perihal: "",
                sifatSurat: "",
                status: "",
                tanggalSuratDari: this.dateStart,
                tanggalSuratKe: this.dateEnd,
                tempatSurat: "",
                tipe: "I",
                internal: '0'
            }
            DataApi.post("surat/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        showSurat(id) {
            this.$store.state.loadingScreen = true
            let ids = this.datas[id].unix
            let payload = {
                unix: ids,
                qr: '1'
            }
            DataApi.post("/export/surat/lihat", payload , {responseType: 'blob'})
            .then(res => {
                this.$store.state.loadingScreen = false
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                const link = document.createElement('a')
                link.href = url
                let title = this.datas[id].jenisSurat + ' - ' + this.datas[id].perihal
                link.setAttribute('download', title)
                document.body.appendChild(link)
                link.click()
            })
        },
        openFile(val) {
            let id = val.split("##")[0]
            let ids = val.split("##")[1]
            let url = this.datas[id].listLampiran[ids].url
            this.showFile(url)
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchUniversal = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        showFile(id) {
            this.$store.state.loadingScreen = true
            DataApiUpload.get('load/' + id)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
                this.$store.state.loadingScreen = false
            })
        },

        editData(val) {
            let generate = this.datas[val]
            this.kodeSurat = generate.unix
            this.dispositionModal = true
        },
        historyData(val) {
            let generate = this.datas[val]
            this.track = generate.listHistory
            this.historyModal = true
        },
        getDataAksi() {
            let payload = {
                action: '',
                limit: 9999,
                pageIn: 1
            }
            DataApi.post("surat/action/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataAksi = response.data.data
                    var i 
                }
            })
        },

        /**
         * SEARCH PESERTA
         */
        getDataPeserta() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 4,
                nama: this.queryPeserta,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPeserta = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPeserta.push(onPush)
                }
            })
        },
        toggleVisiblePeserta() {
            this.visiblePeserta = true;
        },
        hidePeserta() {
            this.visiblePeserta = false;
        },
        toggleCloseVisiblePeserta() {
            setTimeout(this.hidePeserta, 1000);
        },
        itemClickedPeserta(index) {
            this.selectedPeserta = index;
            this.selectItemPeserta();
        },
        selectItemPeserta() {
            if (!this.matchesPeserta.length) {
            return;
            }
            this.selectedItemPeserta = this.matchesPeserta[this.selectedPeserta];
            this.visiblePeserta = false;
            this.queryPeserta = this.selectedItemPeserta.text
            this.idPeserta = this.selectedItemPeserta.value
            var i = 0
            let data = this.sumPeserta
            let push = ''
            if(data.length == 0) {
                push = {
                    nama: this.queryPeserta.split(" - ")[0],
                    id: this.idPeserta
                }
                this.sumPeserta.push(push)
                this.modalPeserta = false
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].id == this.idPeserta) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    push = {
                        nama: this.queryPeserta.split(" - ")[0],
                        id: this.idPeserta
                    }
                    this.sumPeserta.push(push)
                    this.modalPeserta = false
                }
            }
            this.queryPeserta = ''
            this.idPeserta = ''
            if (this.shouldReset) {
            this.queryPeserta = '';
            this.selectedPeserta = 0;
            }
        },
        upPeserta() {
            if (this.selectedPeserta == 0) {
            return;
            }
            this.selectedPeserta -= 1;
            this.scrollToItemPeserta();
        },
        downPeserta() {
            if (this.selectedPeserta >= this.matchesPeserta.length - 1) {
            return;
            }
            this.selectedPeserta += 1;
            this.scrollToItemPeserta();
        },
        scrollToItemPeserta() {
            this.$refs.optionsList.scrollTop = this.selectedPeserta * this.itemHeight;
        },

        deleteSum(id) {
            this.sumPeserta.splice(id, 1)
        },
        goSaveDisposition() {
            let sumAksi = ''
            let sumPeserta = ''
            let dataAksi = this.dataAksi
            let dataPeserta = this.sumPeserta
            let payload = ''
            let gap = '##'
            var i = 0
            for(i=0;i<dataAksi.length;i++) {
                let id = dataAksi[i].unix
                let pushs = document.getElementById(id).checked
                if(pushs == true) {
                    if(sumAksi == '') {
                        sumAksi = id
                    } else {
                        sumAksi = sumAksi + gap + id
                    }
                }
            }
            if(dataPeserta.length != 0) {
                var j = 0
                for(j=0;j<dataPeserta.length;j++) {
                    let idPeg = dataPeserta[j].id
                    if(sumPeserta == '') {
                        sumPeserta = idPeg
                    } else {
                        sumPeserta = sumPeserta + gap + idPeg
                    }
                }
            }
            if(sumPeserta != '') {
                this.$store.state.loadingScreen = true
                payload = {
                    action: sumAksi,
                    kepada: sumPeserta,
                    kodeSurat: this.kodeSurat
                }
                DataApi.post("surat/disposisi/simpan", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        if(response.data.Data1 == 'Y') {
                            this.success = true
                        } else {
                            this.success = false
                        }
                        this.alertMess = response.data.Data2
                    } else {
                        this.alertMess = response.message
                        this.success = false
                    }
                    this.getData()
                    this.dispositionModal = false
                    this.loading = false
                    this.currentAlertCounter = 7
                    this.$store.state.loadingScreen = false
                })
            } else {
                this.errDisposition = '*Harap melengkapi data.'
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataSearchJenis()
        this.getDataSearchMasalah()
        this.getDataAksi()
    },
}
</script>
<style scoped>
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
input[type="checkbox"] {
    width: 15px;
    height: 15px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete, .area-input textarea {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
::v-deep .nav-tabs .nav-item {
    flex-grow: 1;
    position: relative;
    background-color: transparent !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid rgba(224, 224, 224, 1) !important;
    border-radius: 0px;
}
::v-deep .nav-tabs .nav-link.active {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: transparent;
    background-color: white;
    border-bottom: 1px solid rgba(48, 107, 221, 1) !important;
    color: black;
    font-weight: bold;
}
.nav-tabs li a span {
    color: rgba(96, 96, 96, 1) !important;
    font-size: 12px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    background-color: whitesmoke;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 90%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item .is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
label{
	margin: 0;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
</style>